import React from 'react';
import {
    Table as MaterialUITable,
    Paper,
    TableBody,
    TableContainer,
    TableFooter,
    TablePagination,
    TableRow,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import TableHead, { AdditionalTableHeadProps } from './TableHead';
import { HeadCell, TablePaginationWithCount } from './types';

export interface TableProps<T, P> {
    isFirstColumnSticky?: boolean;
    tablePagination?: TablePaginationWithCount;
    headCells: Array<HeadCell<T>>;
    children: React.ReactNode;
    customHeadCellProps?: AdditionalTableHeadProps;
    // Ugly factory pattern. Done due to the sorting in Product statistics.
    // TODO: Tableheads should have `onClick` or `onSort` function which will be called on their click
    TableHeadCellComponent?: React.ComponentType<P>;
    fixedLayout?: boolean;
    className?: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Table = <T, P = any>({
    // eslint-disable-next-line @typescript-eslint/naming-convention
    TableHeadCellComponent,
    children, tablePagination,
    headCells,
    isFirstColumnSticky,
    customHeadCellProps,
    fixedLayout,
    className,
}: TableProps<T, P>) => {
    const footerColSpan = headCells.length;
    const { t } = useTranslation();

    return (
        <Paper elevation={0} square>
            <TableContainer>
                <MaterialUITable
                    style={{ minWidth: '900px', tableLayout:  fixedLayout ? 'fixed' : undefined }}
                    aria-labelledby="tableTitle"
                    aria-label="table"
                    className={className}
                >
                    <TableHead
                        isFirstColumnSticky={isFirstColumnSticky}
                        TableHeadCellComponent={TableHeadCellComponent}
                        headCells={headCells}
                        customHeadCellProps={customHeadCellProps}
                    />
                    <TableBody>
                        {children}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            {tablePagination && (
                                <TablePagination
                                    rowsPerPageOptions={[10, 25, 50]}
                                    colSpan={footerColSpan}
                                    count={tablePagination.count}
                                    rowsPerPage={tablePagination.rowsPerPage}
                                    page={tablePagination.currentPage}
                                    SelectProps={{
                                    inputProps: { 'aria-label': t('rows per page') },
                                    native: true,
                                }}
                                    onChangePage={tablePagination.onChangePage}
                                    onChangeRowsPerPage={tablePagination.onChangeRowsPerPage}
                                />
                            )}
                        </TableRow>
                    </TableFooter>
                </MaterialUITable>
            </TableContainer>
        </Paper>
    );
};

export default Table;
